import { render, staticRenderFns } from "./NFtabs.vue?vue&type=template&id=ff1e7526"
import script from "./NFtabs.vue?vue&type=script&lang=js"
export * from "./NFtabs.vue?vue&type=script&lang=js"
import style0 from "./NFtabs.vue?vue&type=style&index=0&id=ff1e7526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports